import initialState from './state';

import {
  PENDING_STATUS,
  UNDEFINED_STATUS
} from './action-status';

import {
  RESET_STATE,
  SET_CRT_INTERNAL_ID,
  SET_FETCH_NOTARY_CERTIFICATE_STATUS,
  SET_CALCULATE_MERKLE_TREE_ROOT_STATUS,
  SET_MERKLE_TREE_ROOT,
  SET_JSON_ID,
  SET_CRT_HASH_ROOT,
  SET_VALIDATE_HASH_STATUS,
  SET_CALCULATE_CRT_ID_STATUS,
  SET_CALCULATED_CRT_ID,
  SET_VALIDATE_MERKLE_STATUS,
  SET_ITEM_HASH,
  SET_HASH_LIST,
  SET_MERKLE_PROOF,
  SET_HASH_ROOT,
  SET_MERKLE_ROOT,
  SET_TRANSACTION_ID,
  SET_DISPLAY_FILE_NAME,
  SET_CRT_DATE,
  SET_SIGNEE,
  SET_SPL_ITEM_HASH
} from './mutation-types';

function isNeedChangeStatus(status, newStatus) {
  if (status === UNDEFINED_STATUS) {
    return newStatus === PENDING_STATUS;
  }
  return true;
}

export default {
  [RESET_STATE](state) {
    Object.assign(state, initialState());
  },
  [SET_CRT_INTERNAL_ID](state, crtInternalId) {
    state.crtInternalId = crtInternalId;
  },
  [SET_FETCH_NOTARY_CERTIFICATE_STATUS](state, status) {
    if (isNeedChangeStatus(state.fetchNotaryCertificateStatus, status)) {
      state.fetchNotaryCertificateStatus = status;
    }
  },
  [SET_CALCULATE_MERKLE_TREE_ROOT_STATUS](state, status) {
    if (isNeedChangeStatus(state.calculateMerkleRootStatus, status)) {
      state.calculateMerkleRootStatus = status;
    }
  },
  [SET_MERKLE_TREE_ROOT](state, merkleTreeRoot) {
    state.merkleTreeRoot = merkleTreeRoot;
  },
  [SET_JSON_ID](state, jsonId) {
    state.jsonId = jsonId;
  },
  [SET_CRT_HASH_ROOT](state, crtHashRoot) {
    state.crtHashRoot = crtHashRoot;
  },
  [SET_VALIDATE_HASH_STATUS](state, validateHashStatus) {
    state.validateHashStatus = validateHashStatus;
  },
  [SET_CALCULATE_CRT_ID_STATUS](state, status) {
    if (isNeedChangeStatus(state.calculateCrtIdStatus, status)) {
      state.calculateCrtIdStatus = status;
    }
  },
  [SET_CALCULATED_CRT_ID](state, calculatedCrtId) {
    state.calculatedCrtId = calculatedCrtId;
  },
  [SET_VALIDATE_MERKLE_STATUS](state, validateMerkleStatus) {
    state.validateMerkleStatus = validateMerkleStatus;
  },
  [SET_ITEM_HASH](state, itemHash) {
    state.itemHash = itemHash;
  },
  [SET_HASH_LIST](state, hashList) {
    state.hashList = hashList;
  },
  [SET_MERKLE_PROOF](state, merkleProof) {
    state.merkleProof = merkleProof;
  },
  [SET_HASH_ROOT](state, hashRoot) {
    state.hashRoot = hashRoot;
  },
  [SET_MERKLE_ROOT](state, merkleRoot) {
    state.merkleRoot = merkleRoot;
  },
  [SET_TRANSACTION_ID](state, etheriumTransactionId) {
    state.etheriumTransactionId = etheriumTransactionId;
  },
  [SET_DISPLAY_FILE_NAME](state, displayFileName) {
    state.displayFileName = displayFileName;
  },
  [SET_CRT_DATE](state, crtDate) {
    state.crtDate = crtDate;
  },
  [SET_SIGNEE](state, crtSignee) {
    state.crtSignee = crtSignee;
  },
  [SET_SPL_ITEM_HASH](state, splItemHash) {
    state.splItemHash = splItemHash;
  }
};

